

//-------------Importar librerias----------------------------
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';


// ------------------------Valores Constantes----------------------------
import StyleDragArea from './css/button';


const ButtonConmemoracion = ({CopiarFolioSession}) => {
 
  const navigate = useNavigate()
  const handleClick = (link) => {
    navigate(link)
  }





  return (
   <Box sx={{ width: '100%', marginBottom:'0px', marginTop: {xs:'30px',sm:'45px'}, display: 'flex', justifyContent: { xs: 'center', sm: 'start' } }}>
        <StyleDragArea>
          <button type="button" style={{ width: '200px', backgroundColor: '#D14081 !important', borderColor: '#D14081 !important' }} onClick={() => {CopiarFolioSession();handleClick('/Conmemoraciones');}} className="btn btn_rosa" id="hola" >Ir a la conmemoración</button>
        </StyleDragArea>
      </Box>
  );
}

export default ButtonConmemoracion;